var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"chatBox",attrs:{"id":"chatBox","src":_vm.chat_client_url+'/?embed=1&lang='+_vm.lang,"frameborder":"0","allowfullscreen":"","width":"100%","height":"100%"},on:{"load":function($event){return _vm.loaded()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }